import { IBase } from "../base.interface";

export interface IAccountCode extends IBase {
  name: string;

  code: number;
}